import React, {useState} from "react";

export default function Header(props) {
    return(
        <header className="d-flex justify-content-between">
        <div className="d-flex align-items-center">
            <p className="fw700">Data Pool</p>
            <input onChange={e => props.setKeyboard(e.target.value.toLowerCase())} className="search ml-40" placeholder="Search" type="text"/>
            <div className="filter d-flex justify-content-between ml-40">
                <div onClick={() => props.setFilter(1)} className={`d-flex align-items-center  ${props.filter === 1 &&'active'}`}>
                    <p>All</p>
                    <p className="number">{props.verified + props.unverified + props.draft}</p>
                </div>
                <div onClick={() => props.setFilter(3)} className={`d-flex align-items-center  ${props.filter === 3 &&'active'}`}>
                    <p>Unverified</p>
                    <p className="number">{props.unverified}</p>
                </div>
                <div onClick={() => props.setFilter(2)} className={`d-flex align-items-center  ${props.filter === 2 &&'active'}`}>
                    <p>Verified</p>
                    <p className="number">{props.verified}</p>
                </div>
                <div onClick={() => props.setFilter(4)} className={`d-flex align-items-center  ${props.filter === 4 &&'active'}`}>
                    <p>Drafts</p>
                    <p className="number">{props.draft}</p>
                </div>
            </div>
        </div>
        <div onClick={() => props.ShowDataConnector()} className={[localStorage.getItem("role") !== "admin" && "disable", "btn btn-by-icon d-flex align-items-center"].join(" ")}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99997 6.93942V13.0447" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M13.0556 9.99206H6.94446" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M13.9047 1.66666H6.0952C3.37298 1.66666 1.66663 3.59339 1.66663 6.32095V13.679C1.66663 16.4066 3.36504 18.3333 6.0952 18.3333H13.9047C16.6349 18.3333 18.3333 16.4066 18.3333 13.679V6.32095C18.3333 3.59339 16.6349 1.66666 13.9047 1.66666Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <p>New Data Connector</p>
        </div>
        </header>
    )

}
